import { render, staticRenderFns } from "./ColorsForm.vue?vue&type=template&id=1d34c3fc&scoped=true&"
import script from "./ColorsForm.vue?vue&type=script&lang=js&"
export * from "./ColorsForm.vue?vue&type=script&lang=js&"
import style0 from "./ColorsForm.vue?vue&type=style&index=0&id=1d34c3fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d34c3fc",
  null
  
)

export default component.exports